<template>
  <ModuleSection :title="pageTitle">
    <el-form
      class="form-container"
      :model="form"
      ref="ruleForm"
      :rules="rules"
      label-width="180px"
    >
      <el-form-item
        :label="$t('姓名') + '：'"
        class="name-container"
        prop="cbCstName"
      >
        <el-input
          :disabled="actionDetails || actionChange"
          v-model="form.cbCstName"
          :placeholder="$t('请输入中文名称')"
          maxlength="15"
          show-word-limit
        >
        </el-input>
        <div
          v-if="!(actionDetails || actionChange)"
          class="icon-container name"
          @click="handeNameIconClick"
        >
          <div class="icon">·</div>
          <div>{{ $t('若名字带“·”可点击') }}</div>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('身份证号') + '：'"
        prop="idCardNo"
      >
        <el-input
          :disabled="actionDetails || actionChange"
          v-model="form.idCardNo"
          :placeholder="$t('请输入身份证号')"
          maxlength="18"
          show-word-limit
        />
      </el-form-item>
      <el-form-item
        :label="$t('银行名称') + '：'"
        prop="bankCode"
      >
        <el-select
          :disabled="actionDetails"
          v-model="form.bankCode"
          class="w100"
          :placeholder="$t('请输入关键字搜索')"
          filterable
          :filter-method="onSearchBanks"
          @visible-change="visibleChange"
          @change="selectChange"
        >
          <el-option
            v-for="item in bankOptions"
            :key="item.bankCode"
            :label="item.bankCodeName"
            :value="item.bankCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('银行卡号') + '：'"
        class="name-container"
        prop="bankCardNo"
      >
        <el-input
          :disabled="actionDetails"
          v-model="form.bankCardNo"
          maxlength="32"
          show-word-limit
          :placeholder="$t('请输入银行卡号')"
        />
        <div
          v-if="!(actionDetails || actionChange)"
          class="icon-container"
        >
          <div class="icon-tips">
            <div class="text">{{ $t('仅支持绑定带银联标志的中国大陆个人Ⅰ类银行账户（全功能账户）') }}</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('银行卡预留手机号') + '：'"
        prop="bankCardPhoneNo"
      >
        <el-input
          :disabled="actionDetails"
          v-model="form.bankCardPhoneNo"
          maxlength="11"
          show-word-limit
          :placeholder="$t('请输入银行卡预留手机号')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('入驻电商平台企业名称') + '：'"
        class="name-container"
        prop="businessName"
      >
        <el-input
          :disabled="actionDetails"
          v-model="form.businessName"
          :placeholder="$t('请输入企业名称')"
          maxlength="50"
          show-word-limit
        />
        <div
          v-if="!(actionDetails || actionChange)"
          class="icon-container"
        >
          <div class="icon-tips">
            <div class="text">{{ $t('收款人必须是该企业的法人') }}</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('统一社会信用代码') + '：'"
        prop="creditCode"
      >
        <el-input
          :disabled="actionDetails"
          v-model="form.creditCode"
          :placeholder="$t('请输入统一社会信用代码')"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>
      <el-form-item
        :label="$t('营业执照照片') + '：'"
        prop="licenseFiles"
      >
        <UploadFile
          :file-list="form.licenseFiles"
          :disabled="actionDetails"
        >
        </UploadFile>
        <div
          class="form-tip"
          v-if="!actionDetails"
        >
          <div class="require">{{ $t('1、请上传营业执照资料。') }}</div>
          <div>{{ $t('2、支持pdf、jpg、jpeg、png等格式，文件不超过10MB，最多可上传10个文件。') }}</div>
        </div>
      </el-form-item>
      <el-form-item
        v-if="isRefute"
        :label="$t('董事会决议') + '：'"
        prop="auditFiles"
      >
        <UploadFile
          :file-list="form.auditFiles"
          :disabled="actionDetails"
        >
        </UploadFile>
        <template v-if="!actionDetails">
          <div class="template-group">
            <el-button
              class="btn"
              @click="handleClickTemplate('1')"
            >
              {{ $t('下载董事会决议模板') }}
              <img
                src="~@/assets/image/common/down.png"
                alt="down"
              >
            </el-button>
            <el-button
              class="btn"
              @click="handleClickTemplate('2')"
            >
              {{ $t('下载董事会决议示例') }}
              <img
                src="~@/assets/image/common/down.png"
                alt="down"
              >
            </el-button>
          </div>
          <div class="form-tip">
            <div class="require">{{ $t('1、请上传董事会决议资料。') }}</div>
            <div>{{ $t('2、支持pdf、xls、jpg、jpeg、png等格式，文件不超过10MB，最多可上传10个文件。') }}</div>
          </div>
        </template>

      </el-form-item>

      <!-- <el-form-item
        label="状态"
        prop="checkStatus"
        v-if="actionDetails || actionChange"
      >
        <p>{{form.checkStatusName}}</p>
      </el-form-item>
      <el-form-item
        label="备注"
        prop="checkRemark"
        v-if="actionDetails || actionChange"
      >
        <p>{{form.checkRemark}}</p>
      </el-form-item> -->
    </el-form>

    <div class="button-group">
      <el-button
        v-if="!actionDetails"
        :loading="bindLoading"
        type="primary"
        @click="onSubmit"
      >{{ $t('提交') }}
      </el-button>
      <el-button
        type="info"
        @click="$router.go(-1)"
      >{{ $t('返回') }}</el-button>
    </div>
  </ModuleSection>
</template>
<script>
import { mapState } from 'vuex'
import api from '../../api/payee'
export default {
  props: {
    // add：添加，changes：修改，resubmit：重新提交，details：详情
    actionType: {
      type: String,
      default () {
        return 'details'
      }
    }
  },
  data () {
    return {
      bankList: [],
      bankOptions: [],
      form: {
        cbCstName: '',
        idCardNo: '',
        bankCode: '',
        bankCardNo: '',
        bankCardPhoneNo: '',
        businessName: '',
        creditCode: '',
        licenseFiles: [],
        auditFiles: []
      },
      bindLoading: false,
      fileParams: {},
      isRefute: false
    }
  },
  computed: {
    ...mapState('login', ['loginInfo']),
    rules () {
      return {
        // 姓名
        cbCstName: [
          { required: true, message: this.$t('请输入姓名') }
        ],
        // 身份证号
        idCardNo: [
          { required: true, message: this.$t('请输入身份证号'), trigger: 'blur' }
        ],
        bankCode: [
          { required: true, message: this.$t('请选择银行名称'), trigger: 'change' }
        ],
        // 银行账号
        bankCardNo: [
          { required: true, message: this.$t('请输入银行卡号'), trigger: 'blur' },
          { pattern: /^\d{1,}$/, message: this.$t('请输入正确银行卡号'), trigger: 'blur' }
        ],
        // 手机号
        bankCardPhoneNo: [
          { required: true, message: this.$t('请输入银行卡预留手机号'), trigger: 'blur' },
          { pattern: /^\d{7,16}$/, message: this.$t('请输入正确手机号'), trigger: 'blur' }
        ],
        // 电商平台名称
        businessName: [
          { required: true, message: this.$t('请输入入驻电商平台企业名称'), trigger: 'blur' }
        ],
        // 统一社会信用代码
        creditCode: [
          { required: true, message: this.$t('请输入统一社会信用代码'), trigger: 'blur' }
        ],
        // 营业执照照片
        licenseFiles: [
          { required: true, message: this.$t('请上传营业执照照片'), trigger: 'change' }
        ],
        // 董事会决议
        auditFiles: [
          { required: true, message: this.$t('请上传董事会决议'), trigger: 'change' }
        ]
      }
    },
    pageTitle () {
      const { actionType } = this.$props
      const title = actionType === 'add' ? '收款人管理-新增银行卡'
        : actionType === 'details' ? '收款人管理-详情'
          : actionType === 'changes' ? '收款人管理-变更银行卡' : '收款人管理-新增银行卡'
      return title
    },
    // 详情
    actionDetails () {
      return this.$props.actionType === 'details'
    },
    // 变更
    actionChange () {
      return this.$props.actionType === 'changes'
    },
    // 重新提交
    actionResubmit () {
      return this.$props.actionType === 'resubmit'
    }
  },
  created () {
    this.singleUBOCheck()
    this.getBankList()
  },
  methods: {
    singleUBOCheck () {
      api.singleUBOCheck({
        cbCstNo: this.loginInfo.customerId
      }).then(res => {
        this.isRefute = !res.single
      })
    },
    getBankList () {
      api.listBankCodeInfo().then(res => {
        this.bankList = Object.freeze(res.bankCodeInfoList)
        this.getDetails()
      })
    },
    getDetails () {
      const { settlementUserInfoId } = this.$route.query
      if (!settlementUserInfoId) return
      api.userDetails({
        settlementUserInfoId
      }).then(res => {
        this.form = {
          ...res,
          licenseFiles: (res.licenseFiles && res.licenseFiles.map(item => {
            return {
              ...item,
              path: item.filePath,
              name: item.fileName
            }
          })) || [],
          auditFiles: (res.auditFiles && res.auditFiles.map(item => {
            return {
              ...item,
              path: item.filePath,
              name: item.fileName
            }
          })) || []
        }
        this.onSearchBanks()
      })
    },
    // 设置bankCodeName
    selectChange (data) {
      const item = this.bankList.find((item) => item.bankCode === data)
      this.form.bankCodeName = item.bankCodeName
    },
    visibleChange (flag) {
      if (flag) {
        this.onSearchBanks()
      }
    },
    onSearchBanks (query) {
      if (query) {
        const list = this.bankList.filter(item => {
          return item.bankCodeName.toLowerCase().includes(query.toLocaleString())
        })
        if (list.length > 200) {
          this.bankOptions = list.slice(0, 200)
        } else {
          this.bankOptions = list
        }
      } else {
        this.bankOptions = this.bankList.slice(0, 200)
        if (this.form.bankCode) {
          this.bankList.find((item, index) => {
            if (item.bankCode === this.form.bankCode && index > 200) {
              this.bankOptions.push(item)
            }
            if (item.bankCode === this.form.bankCode) {
              return item
            }
          })
        }
      }
    },
    bank4Check () {

    },
    handleClickTemplate (type) {
      if (+type === 1) {
        window.open(process.env.BASE_URL + 'download/Board Resolution-(Full name of corporation).pdf')
      } else {
        window.open(process.env.BASE_URL + 'download/Board Resolution-(XXXXXXXX LIMITED)-examples.pdf')
      }
    },
    handeNameIconClick () {
      if (!this.form.cbCstName || !this.form.cbCstName.length) return
      if (this.form.cbCstName.length >= 15) return
      this.form.cbCstName = this.form.cbCstName + '·'
    },
    onSubmit () {
      let fn = null
      const { actionType } = this.$props
      if (actionType === 'add') {
        fn = api.userAdd
      }
      if (actionType === 'changes') {
        fn = api.modifyBankCard
      }
      if (actionType === 'resubmit') {
        fn = api.reCommit
      }

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          fn({
            cbCstNo: this.loginInfo.customerId,
            ...this.form,
            auditFiles: this.form.auditFiles.map(item => {
              return {
                ...item,
                filePath: item.path,
                fileName: item.name
              }
            }),
            licenseFiles: this.form.licenseFiles.map(item => {
              return {
                ...item,
                filePath: item.path,
                fileName: item.name
              }
            })
          }).then(res => {
            console.log(res)
            this.$router.push({
              name: 'ReceiverMenageResult',
              query: {
                actionType,
                settlementUserInfoId: res.settlementUserInfoId,
                notes: res.notes,
                auditStatus: res.auditStatus,
                single: !this.isRefute
              }
            })
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.w100 {
  width: 100%;
}
/deep/ .el-input {
  input {
    padding-right: 49px;
  }
}
.form-container {
  width: 700px;
  .name-container {
    position: relative;

    .icon-container {
      position: absolute;
      top: 10px;
      left: 536px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      font-size: 14px;
      font-weight: 300;
      color: @black;
      line-height: 14px;
      user-select: none;
      word-break: keep-all;
      z-index: 1;
      &.name {
        cursor: pointer;
      }
      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background: #ecf0ff;
        border-radius: 4px;
        margin-right: 10px;
      }
      .icon-tips {
        position: relative;
        width: 20px;
        height: 20px;
        background-image: url('~@/assets/image/icons/icon_input_tips.png');
        background-repeat: no-repeat;
        background-size: cover;
        &:hover {
          .text {
            display: block;
          }
        }
        .text {
          display: none;
          position: absolute;
          left: -85px;
          top: 35px;
          min-width: 224px;
          padding: 20px 30px;
          border-radius: 4px;
          background: @white;
          box-shadow: 0px 6px 20px 0px rgba(51, 55, 82, 0.1);
          line-height: 28px;
          &::after {
            content: '';
            position: absolute;
            left: 85px;
            top: -10px;
            width: 20px;
            height: 20px;
            transform: rotate(45deg);
            background: @white;
          }
        }
      }
    }
  }

  .form-tip {
    margin-top: 20px;
    font-size: 12px;
    font-weight: 300;
    color: #a1a7c4;
    line-height: 18px;
    & > .require {
      position: relative;
      &::before {
        content: '*';
        position: absolute;
        color: @red;
        left: -10px;
        top: 2px;
      }
    }
  }
}
.template-group {
  margin: 20px 0;
  .btn {
    font-size: 14px;
    /deep/ span {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  img {
    width: 24px;
    height: 24px;
    margin-left: 10px;
  }
}
.button-group {
  margin-left: 180px;
  margin-top: 40px;
}
</style>
